import React, { Component } from 'react';
import LogInNavBar from './LogInNavBar.js';
import NavBar from './NavBar.js';
import Footer from './Footer.js';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import axios from "axios";
import { properties } from './properties.js';
import i18n from './I18N/I18n.js'; 
import { withTranslation } from 'react-i18next';
import { apiSecuredRequest, isUserOrWallet, cargarIdiomaPreferido} from './functions.js';
import "./css/login.css";


class TerminosYCondiciones extends Component {

  async componentDidMount() {
    await cargarIdiomaPreferido(this.cambiarIdioma);

    await this.loadUserMail()

  }

  cambiarIdioma = (idioma) => {
      const { i18n } = this.props;
      i18n.changeLanguage(idioma); 
      this.forceUpdate(); 
      Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
    };


    async loadUserMail() {

        const email = Cookies.get("email")
        
        let bearerVar;
        bearerVar = Cookies.get("id");
        this.setState({ bearer: bearerVar })
        const pendingSign = Cookies.get("pendingSign")
        this.setState({ pendingSign })
        let account = await isUserOrWallet(email, bearerVar);
        this.setState({account})
        this.setState({ email })
        
      }


      _acceptTermsAndConditions = async (terminosYcondiciones) => {
        if (!this.state.isChecked) {
          Swal.fire('Debes aceptar los terminos y condiciones', '', 'info')
        } 
        let updateData;
        let loggedUserInfo;
        let passWord;
        if(this.state.account != 0) {

            let walletDir = JSON.stringify({
              "walletDir": `${this.state.account}`
            });

            const usuario = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/getUserByWalletDir`, walletDir, this.state.bearer);
            loggedUserInfo = usuario.data;
            passWord = "noPass";

        } else {

            let email = JSON.stringify({
              "email": `${this.state.email}`
            });
      
            const userInfo = await axios({
              method: "post",
              url: `${properties.apiUrl}/certificat/api/usuario/getUser`,
              data: email,
              headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${this.state.bearer}`
              },
            })
          
            loggedUserInfo = userInfo.data;
            passWord = Cookies.get("newPass");
        
        }

        updateData = JSON.stringify({
          "password": passWord,
          "email": loggedUserInfo.email,
          "nombre": loggedUserInfo.nombre,
          "apellido1": loggedUserInfo.apellido1,
          "apellido2": loggedUserInfo.apellido2,
          "activeUser": true,
          "documento": loggedUserInfo.documento,
          "walletDir": loggedUserInfo.walletDir,
          "termsAndConditions": true,
          "proofUWallet": loggedUserInfo.proofUWallet,
          "codigoPais": loggedUserInfo.codigoPais,
          "userRol": {
            "id": "2",
            "rol": "USER"
          }
        });
        
        const userResponse = await axios({
          method: "put",
          url: `${properties.apiUrl}/certificat/api/usuario/update/${loggedUserInfo.id}`,
          data: updateData,
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${this.state.bearer}`
          },
        })
        Cookies.remove("pendingSign")
        window.location.href = "/listaEmpresas"
    
      }
    


    _manageTerminosYcondiciones = async () => {

        this.setState({ isChecked: !this.state.isChecked })
    
      }


      constructor(props) {
        super(props)
        this.state = {
          account: null,
          bearer: null,
          email: undefined,
          isChecked: false,
          pendingSign: null
        }
      }

      render() {

        if (this.state.pendingSign == "true") {
    
          return (
            <>
    <div>
    <LogInNavBar
                cambiarIdioma={this.cambiarIdioma}
              />
      <form
        onSubmit={(event) => {
          event.preventDefault();
          const terminosYcondiciones = this.state.isChecked;
          this._acceptTermsAndConditions(terminosYcondiciones);
        }}
      >
        <div className="popup_terms_conditions">
          <p className="text_terms_conditions_long">
            <b><span className="title_terms_privacy">{i18n.t('terms.title')}</span></b><br /><br />
            {i18n.t('terms.enterpriseAccount')}<br /><br />
            {i18n.t('terms.effectiveDate')}<br /><br />
            {i18n.t('terms.introText')}<br /><br />
            {i18n.t('terms.nftsDescription')}<br />
            {i18n.t('terms.contact')}<br /><br />

            <b>{i18n.t('terms.legalNotice')}</b><br />
            {i18n.t('terms.legalContact')}<br />
            {i18n.t('terms.director')}<br />
            {i18n.t('terms.publisher')}<br />
            {i18n.t('terms.hostedBy')}<br />
            {i18n.t('terms.emailAddress')}<br />
            {i18n.t('terms.postalAddress')}<br /><br />

            <b>{i18n.t('terms.access.title')}</b><br />
            {i18n.t('terms.access.whoCanUse')}<br />
            {i18n.t('terms.access.price')}<br />
            {i18n.t('terms.access.howToAccess')}<br /><br />

            <b>{i18n.t('terms.use.title')}</b><br />
            {i18n.t('terms.use.license')}<br />
            {i18n.t('terms.use.requirements')}<br />
            <ul>
              <li>{i18n.t('terms.use.noDuplication')}</li>
              <li>{i18n.t('terms.use.noReverseEngineering')}</li>
              <li>{i18n.t('terms.use.noModification')}</li>
              <li>{i18n.t('terms.use.noDerivatives')}</li>
              <li>{i18n.t('terms.use.noPublishing')}</li>
              <li>{i18n.t('terms.use.noSublicense')}</li>
              <li>{i18n.t('terms.use.noAlteration')}</li>
              <li>{i18n.t('terms.use.noErrorCorrection')}</li>
              <li>{i18n.t('terms.use.noInfringement')}</li>
            </ul><br /><br />

            <b>{i18n.t('terms.intellectualProperty.title')}</b><br />
            {i18n.t('terms.intellectualProperty.description')}<br />
            {i18n.t('terms.intellectualProperty.nftsRights')}<br /><br />

            <b>{i18n.t('terms.responsibility.title')}</b><br />
            {i18n.t('terms.responsibility.ourResponsibilities')}<br />
            {i18n.t('terms.responsibility.yourResponsibilities')}<br /><br />

            <b>{i18n.t('terms.dispute.title')}</b><br />
            {i18n.t('terms.dispute.law')}<br />
            {i18n.t('terms.dispute.resolution')}<br /><br />

            <b>{i18n.t('terms.modification.title')}</b><br />
            {i18n.t('terms.modification.description')}<br /><br />

            <b>{i18n.t('terms.contact7.title')}</b><br />
            {i18n.t('terms.contact7.description')}<br /><br />

            <b><span className="title_terms_privacy">{i18n.t('terms.privacyPolicy.title')}</span></b><br /><br />

            <b>${i18n.t('terms.privacyPolicy.dataCollection.title')}</b><br />
            {i18n.t('terms.privacyPolicy.dataCollection.personalData')}<br />
            {i18n.t('terms.privacyPolicy.dataCollection.dataSharing')}<br />
            {i18n.t('terms.privacyPolicy.dataCollection.dataProtection')}<br /><br />

            <b>{i18n.t('terms.privacyPolicy.cookies.title')}</b><br />
            {i18n.t('terms.privacyPolicy.cookies.description')}<br /><br />

            <b>{i18n.t('terms.privacyPolicy.dataRetention.title')}</b><br />
            {i18n.t('terms.privacyPolicy.dataRetention.description')}<br /><br />

            <b>{i18n.t('terms.privacyPolicy.yourRights.title')}</b><br />
            {i18n.t('terms.privacyPolicy.yourRights.description')}<br /><br />

            <b>{i18n.t('terms.privacyPolicy.changes.title')}</b><br />
            {i18n.t('terms.privacyPolicy.changes.description')}<br /><br />

            <b>{i18n.t('terms.privacyPolicy.contact.title')}</b><br />
            {i18n.t('terms.privacyPolicy.contact.description')}<br /><br />
          </p>

          <div className="checkbox-label">
            <input
              type="checkbox"
              id="accept_terms"
              className="checkbox-input"
              checked={this.state.isChecked}
              onChange={this._manageTerminosYcondiciones}
            />
            <label htmlFor="accept_terms">{i18n.t('terms.checkboxLabel')}</label>
          </div>

          <button type="submit" className="submit-button" disabled={!this.state.isChecked}>
            {i18n.t('aceptar')}
          </button>
        </div>
      </form>
    </div>
    
    
            </>
          );
    
        } else {
    
          return (
            <>
            <NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} />
                <div>
    
     
        <div className="popup_terms_conditions">
          <p className="text_terms_conditions_long">
            <b><span className="title_terms_privacy">{i18n.t('terms.title')}</span></b><br /><br />
            {i18n.t('terms.enterpriseAccount')}<br /><br />
            {i18n.t('terms.effectiveDate')}<br /><br />
            {i18n.t('terms.introText')}<br /><br />
            {i18n.t('terms.nftsDescription')}<br />
            {i18n.t('terms.contact')}<br /><br />

            <b>{i18n.t('terms.legalNotice')}</b><br />
            {i18n.t('terms.legalContact')}<br />
            {i18n.t('terms.director')}<br />
            {i18n.t('terms.publisher')}<br />
            {i18n.t('terms.hostedBy')}<br />
            {i18n.t('terms.emailAddress')}<br />
            {i18n.t('terms.postalAddress')}<br /><br />

            <b>{i18n.t('terms.access.title')}</b><br />
            {i18n.t('terms.access.whoCanUse')}<br />
            {i18n.t('terms.access.price')}<br />
            {i18n.t('terms.access.howToAccess')}<br /><br />

            <b>{i18n.t('terms.use.title')}</b><br />
            {i18n.t('terms.use.license')}<br />
            {i18n.t('terms.use.requirements')}<br />
            <ul>
              <li>{i18n.t('terms.use.noDuplication')}</li>
              <li>{i18n.t('terms.use.noReverseEngineering')}</li>
              <li>{i18n.t('terms.use.noModification')}</li>
              <li>{i18n.t('terms.use.noDerivatives')}</li>
              <li>{i18n.t('terms.use.noPublishing')}</li>
              <li>{i18n.t('terms.use.noSublicense')}</li>
              <li>{i18n.t('terms.use.noAlteration')}</li>
              <li>{i18n.t('terms.use.noErrorCorrection')}</li>
              <li>{i18n.t('terms.use.noInfringement')}</li>
            </ul><br /><br />

            <b>{i18n.t('terms.intellectualProperty.title')}</b><br />
            {i18n.t('terms.intellectualProperty.description')}<br />
            {i18n.t('terms.intellectualProperty.nftsRights')}<br /><br />

            <b>{i18n.t('terms.responsibility.title')}</b><br />
            {i18n.t('terms.responsibility.ourResponsibilities')}<br />
            {i18n.t('terms.responsibility.yourResponsibilities')}<br /><br />

            <b>{i18n.t('terms.dispute.title')}</b><br />
            {i18n.t('terms.dispute.law')}<br />
            {i18n.t('terms.dispute.resolution')}<br /><br />

            <b>{i18n.t('terms.modification.title')}</b><br />
            {i18n.t('terms.modification.description')}<br /><br />

            <b>{i18n.t('terms.contact7.title')}</b><br />
            {i18n.t('terms.contact7.description')}<br /><br />

            <b><span className="title_terms_privacy">{i18n.t('terms.privacyPolicy.title')}</span></b><br /><br />

            <b>${i18n.t('terms.privacyPolicy.dataCollection.title')}</b><br />
            {i18n.t('terms.privacyPolicy.dataCollection.personalData')}<br />
            {i18n.t('terms.privacyPolicy.dataCollection.dataSharing')}<br />
            {i18n.t('terms.privacyPolicy.dataCollection.dataProtection')}<br /><br />

            <b>{i18n.t('terms.privacyPolicy.cookies.title')}</b><br />
            {i18n.t('terms.privacyPolicy.cookies.description')}<br /><br />

            <b>{i18n.t('terms.privacyPolicy.dataRetention.title')}</b><br />
            {i18n.t('terms.privacyPolicy.dataRetention.description')}<br /><br />

            <b>{i18n.t('terms.privacyPolicy.yourRights.title')}</b><br />
            {i18n.t('terms.privacyPolicy.yourRights.description')}<br /><br />

            <b>{i18n.t('terms.privacyPolicy.changes.title')}</b><br />
            {i18n.t('terms.privacyPolicy.changes.description')}<br /><br />

            <b>{i18n.t('terms.privacyPolicy.contact.title')}</b><br />
            {i18n.t('terms.privacyPolicy.contact.description')}<br /><br />
          </p>
        </div>
      
    </div>
              <Footer />
            </>
          );
    
        }
    
    
    
    
    
      }
    }

    export default withTranslation()(TerminosYCondiciones);

